import { Seo } from "src/components/seo";
import { usePageView } from "src/hooks/use-page-view";
import { useDispatch, useSelector } from "src/store";
import type { Page as PageType } from "src/types/page";
import { Box, Stack } from "@mui/material";
import { tokens } from "src/locales/tokens";
import { useTranslation } from "react-i18next";
import StrategyContentRoot from "./strategy-content-root";
import { InstagramProfilePart } from "src/sections/dashboard/instagram/instagram-profile-part";
import { PlanType } from "src/types/strategy";
import { PaidAccess } from "src/sections/common/paid-access";
import { useRouter } from "src/hooks/use-router";
import { useCallback, useEffect } from "react";
import NotFound from "src/sections/errors/not-found";
import ServerError from "src/sections/errors/server-error";
import { ERRORS } from "src/consts";
import { thunks as socialProfileThunks } from "src/thunks/social-profile";
import { SocialProfileType } from "src/types/social-profile";

const Page: PageType = () => {
  const { t } = useTranslation();
  usePageView();

  const dispatch = useDispatch();
  const router = useRouter();

  const {
    item: socialProfile,
    error: socialProfileError,
    isLoading: socialProfileIsLoading,
  } = useSelector((state) => state.socialProfile);

  const { strategyId } = useSelector((state) => state.settings);
  const { item } = useSelector((state) => state.strategy);

  const loadData = useCallback(async () => {
    await dispatch(
      socialProfileThunks.getSocialProfile(
        strategyId!,
        SocialProfileType.Instagram
      )
    );
  }, [dispatch, strategyId]);

  useEffect(() => {
    loadData();

    return () => {
      dispatch(socialProfileThunks.clearSocialProfile());
    };
  }, [loadData, dispatch]);

  if (socialProfileError) {
    debugger;
    if (socialProfileError.status !== ERRORS.NOT_FOUND_ERROR.status) {
      return <ServerError showBackButton={false} />;
    }
  }

  if (!item) {
    return null;
  }
  return (
    <>
      <Seo
        title={t(tokens.recommendations.instagram.profile.title) as string}
      />
      <StrategyContentRoot>
        <Box
          sx={{
            "--Content-maxWidth": "var(--maxWidth-lg)",
            maxWidth: "var(--Content-maxWidth)",
            m: "var(--Content-margin)",
            p: "var(--Content-padding)",
            width: "var(--Content-width)",
          }}
        >
          <Box
            sx={{
              flex: "1 1 auto",
              overflow: "hidden",
              position: "relative",
            }}
          >
            <Stack
              sx={{ px: 1, pb: 1 }}
              spacing={3}
            >
              {item?.planType === PlanType.Free ? (
                <PaidAccess
                  title={t(tokens.recommendations.instagram.profile.header)}
                />
              ) : (
                <InstagramProfilePart
                  strategyId={item!.id}
                  socialProfile={socialProfile}
                />
              )}
            </Stack>
          </Box>
        </Box>
      </StrategyContentRoot>
    </>
  );
};

export default Page;
